import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useClientSaveFinancialPositionMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { ClientSaveFinancialPositionParam } from 'api/types/params';

import { parseClientEntity, parseSaveFinancialPositionParam } from '../helpers';

export const useClientSaveFinancialPosition = () => {
  const [saveFinancialPosition, { data, loading, error: apolloError }] =
    useClientSaveFinancialPositionMutation();

  const error = useError(apolloError);

  return {
    data: data?.clientSaveFinancialPosition
      ? parseClientEntity(data.clientSaveFinancialPosition)
      : undefined,
    loading,
    error,
    saveFinancialPosition: useCallback(
      async (id: string, params: ClientSaveFinancialPositionParam) => {
        const input = parseSaveFinancialPositionParam(params);
        const res = await saveFinancialPosition({
          variables: { id, input },
        });
        return res.data?.clientSaveFinancialPosition
          ? parseClientEntity(res.data.clientSaveFinancialPosition)
          : undefined;
      },
      [saveFinancialPosition]
    ),
  };
};
